module.exports = __webpack_public_path__ + "media/images/hackerrank/fullstack-55e3e620594173f8d8d48a8a1afb02e2.png";